import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { actions } from "..";
import { makeAllObjToArr } from "../../helpers";
import { financeServices } from "../../services";
import * as actionTypes from "../actionTypes";

function* getSalesData(action) {
  const res = yield call(financeServices?.getSalesData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveSalesData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getOtherIncomeDataOptions(action) {
  const res = yield call(
    financeServices?.getOtherIncomeDataOptions,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOtherIncomeDataOptions(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postOtherIncomeData(action) {
  const res = yield call(financeServices?.postOtherIncomeData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOtherIncomeDataOptions(data));
    yield action?.payload.history.push("/finance/sales");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* postOtherIncomeEditData(action) {
  const res = yield call(
    financeServices?.postOtherIncomeEditData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOtherIncomeEditData(data));
    console.log(action, "llllll");
    yield action?.payload.history.push("/finance/sales");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getOrderPaymentsData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getOrderPaymentsItemData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsItemData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsItemData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getOrderPaymentsComponentData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsComponentData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsComponentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getOrderPaymentsBundleItemData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsBundleItemData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsBundleItemData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getOrderPaymentsViewBillsData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsViewBillsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsViewBillsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getOrderPaymentsBillsItemData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsBillsItemData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsItemData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getOrderPaymentsBillsComponentData(action) {
  const res = yield call(
    financeServices?.getOrderPaymentsBillsComponentData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveOrderPaymentsComponentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postOrderPaymentsPrintBill(action) {
  const res = yield call(
    financeServices?.postOrderPaymentsPrintBill,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.pdf_url;
    window.open(data, "_blank");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getRefundsData(action) {
  const res = yield call(financeServices?.getRefundsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveRefundsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getBillData(action) {
  const res = yield call(financeServices?.getBillData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveRefundsBillData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getInnerMenuItemsData(action) {
  const res = yield call(
    financeServices?.getInnerMenuItemsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveInnerMenuItemsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getInnerComponentData(action) {
  const res = yield call(
    financeServices?.getInnerComponentData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveInnerComponentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getVoidsData(action) {
  const res = yield call(financeServices?.getVoidsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveVoidsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getDiscountsData(action) {
  const res = yield call(financeServices?.getDiscountsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveDiscountsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getTipsData(action) {
  const res = yield call(financeServices?.getTipsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveTipsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPromotionsData(action) {
  const res = yield call(financeServices?.getPromotionsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePromotionsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPromotionsSalesData(action) {
  const res = yield call(
    financeServices?.getPromotionsSalesData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePromotionsSalesData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getExpensesData(action) {
  const res = yield call(financeServices?.getExpensesData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveExpensesData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPaymentsData(action) {
  const res = yield call(financeServices?.getPaymentsData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getAddPaymentsFormData(action) {
  const res = yield call(
    financeServices?.getAddPaymentsFormData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveAddPaymentsFormData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postAddPaymentsFormData(action) {
  console.log(action?.payload, "action?.payload");

  const res = yield call(
    financeServices?.postAddPaymentsFormData,
    action?.payload?.formData
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    // yield put(actions?.saveAddPaymentsFormData(data));
    action?.payload?.history.push("/finance/payments");
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getExpenseTypeData(action) {
  const res = yield call(financeServices?.getExpenseTypeData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveExpenseTypeData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getInvoicesData(action) {
  const res = yield call(financeServices?.getInvoicesData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveInvoicesData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPayTradeLiabilityData(action) {
  const res = yield call(
    financeServices?.getPayTradeLiabilityData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePayTradeLiabilityData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPayOtherDebtData(action) {
  const res = yield call(financeServices?.getPayOtherDebtData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePayOtherDebtData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getBuyAssetData(action) {
  const res = yield call(financeServices?.getBuyAssetData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveBuyAssetData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPaymentAccountData(action) {
  const res = yield call(
    financeServices?.getPaymentAccountData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePaymentAccountData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getAddAssetData(action) {
  const res = yield call(financeServices?.getAddAssetData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveAddAssetData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postAddAssetData(action) {
  const res = yield call(financeServices?.postAddAssetData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveBuyAssetData(data));
    yield put(
      actions?.setFormState({ formName: "assetFormState", formState: false })
    );
    yield put(
      actions?.setFormState({
        formName: "editAssetFormState",
        formState: false,
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postDeleteAddAssetData(action) {
  const res = yield call(
    financeServices?.postDeleteAddAssetData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveBuyAssetData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getApLiabilityData(action) {
  const res = yield call(financeServices?.getApLiabilityData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveApLiabilityData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getViewPaymentData(action) {
  const res = yield call(financeServices?.getViewPaymentData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveViewPaymentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getEditPaymentData(action) {
  const res = yield call(financeServices?.getEditPaymentData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveEditPaymentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postEditPaymentData(action) {
  const res = yield call(financeServices?.postEditPaymentData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    // yield put(actions?.saveEditPaymentData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getApprovedPaymentsData(action) {
  const res = yield call(
    financeServices?.getApprovedPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveApprovedPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getSubmittedPaymentsData(action) {
  const res = yield call(
    financeServices?.getSubmittedPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveSubmittedPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getPendingPaymentsData(action) {
  const res = yield call(
    financeServices?.getPendingPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.savePendingPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* getRejectedPaymentsData(action) {
  const res = yield call(
    financeServices?.getRejectedPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveRejectedPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}
function* postApprovedPaymentsData(action) {
  const res = yield call(
    financeServices?.postApprovedPaymentsData,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions?.saveApprovedPaymentsData(data));
  } else {
    yield put(
      actions?.showNotificationWithTimeout(res?.message ?? "", "error")
    );
  }
}

function* getFinancePayablesOutstanding(action) {
  const res = yield call(
    financeServices?.getFinancePayablesOutstanding,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveFinanceValues({
        financePayablesOutstanding: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* getFinanceApCreditNotes(action) {
  const res = yield call(
    financeServices?.getFinanceApCreditNotes,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveFinanceValues({
        financeApCreditNotes: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* getApCreditNotesOption(action) {
  const res = yield call(
    financeServices?.getApCreditNotesOption,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions.saveFinanceValues({
        financeApCreditNotesOption: makeAllObjToArr({
          ...data,
          ...data?.getLineItem,
        }),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}
function* getApCreditNotesTaxPercentage(action) {
  const res = yield call(
    financeServices?.getApCreditNotesTaxPercentage,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    const financeReducer = yield select((state) => state?.financeReducer);
    console.log(financeReducer, "financeReducerfinanceReducerfinanceReducer");
    yield put(
      actions.saveFinanceValues({
        financeApCreditNotesOption: {
          ...financeReducer?.financeApCreditNotesOption,
          tax_charged: data?.Tax?.tax_charged,
        },
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}
function* postApCreditNotesData(action) {
  const res = yield call(
    financeServices?.postApCreditNotesData,
    action?.payload?.data
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    // const financeReducer = yield select((state) => state?.financeReducer);
    yield put(
      actions.saveFinanceValues({
        financeApCreditNotes: makeAllObjToArr(data),
      })
    );
    action?.payload?.history.push("/finance/payables/ap-credit-notes");
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* getEditApCreditNotesData(action) {
  const res = yield call(
    financeServices?.getEditApCreditNotesData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    // const financeReducer = yield select((state) => state?.financeReducer);
    yield put(
      actions.saveFinanceValues({
        financeEditApCreditNotesData: makeAllObjToArr(
          { ...data, ...data?.getLineItem },
          "credit_note"
        ),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* postCreditNotesAttachment(action) {
  const res = yield call(
    financeServices?.postCreditNotesAttachment,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}
function* getFinanceAssets(action) {
  const res = yield call(financeServices?.getFinanceAssets, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions?.saveFinanceValues({
        financeAssets: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}
function* downloadFinanceAssets(action) {
  const res = yield call(
    financeServices?.downloadFinanceAssets,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.export_excel;
    window.open(data, "_blank");
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* downloadFinanceVoucher(action) {
  const res = yield call(
    financeServices?.downloadFinanceVoucher,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.url;
    window.open(data, "_blank");
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* getFinanceVouchers(action) {
  const res = yield call(financeServices?.getFinanceVouchers, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions?.saveFinanceValues({
        financeVouchers: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* getFinanceVouchersList(action) {
  const res = yield call(
    financeServices?.getFinanceVouchersList,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(
      actions?.saveFinanceValues({
        financeVouchersList: makeAllObjToArr(data),
      })
    );
  } else {
    yield put(
      actions?.showNotificationWithTimeout(`${res?.message ?? ""}`, "error")
    );
  }
}

function* financeSaga() {
  // sales
  yield takeLatest(actionTypes?.GET_SALES_DATA, getSalesData);
  yield takeLatest(
    actionTypes?.GET_OTHER_INCOME_DATA_OPTIONS,
    getOtherIncomeDataOptions
  );
  yield takeLatest(actionTypes?.POST_OTHER_INCOME_DATA, postOtherIncomeData);
  yield takeLatest(
    actionTypes?.POST_OTHER_INCOME_EDIT_DATA,
    postOtherIncomeEditData
  );

  // order payments
  yield takeLatest(actionTypes?.GET_ORDER_PAYMENTS_DATA, getOrderPaymentsData);
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_ITEM_DATA,
    getOrderPaymentsItemData
  );
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_BUNDLE_ITEM_DATA,
    getOrderPaymentsBundleItemData
  );
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_COMPONENT_DATA,
    getOrderPaymentsComponentData
  );
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_VIEW_BILLS_DATA,
    getOrderPaymentsViewBillsData
  );
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_BILLS_ITEM_DATA,
    getOrderPaymentsBillsItemData
  );
  yield takeLatest(
    actionTypes?.GET_ORDER_PAYMENTS_BILLS_COMPONENT_DATA,
    getOrderPaymentsBillsComponentData
  );
  yield takeLatest(
    actionTypes?.POST_ORDER_PAYMENTS_PRINT_BILL,
    postOrderPaymentsPrintBill
  );

  // refunds
  yield takeLatest(actionTypes?.GET_REFUNDS_DATA, getRefundsData);
  yield takeLatest(actionTypes?.GET_REFUNDS_BILL_DATA, getBillData);
  yield takeLatest(
    actionTypes?.GET_INNER_MENU_ITEMS_DATA,
    getInnerMenuItemsData
  );
  yield takeLatest(
    actionTypes?.GET_INNER_COMPONENT_DATA,
    getInnerComponentData
  );
  // voids
  yield takeLatest(actionTypes?.GET_VOIDS_DATA, getVoidsData);
  // discounts
  yield takeLatest(actionTypes?.GET_DISCOUNTS_DATA, getDiscountsData);
  // tips
  yield takeLatest(actionTypes?.GET_TIPS_DATA, getTipsData);
  // promotions
  yield takeLatest(actionTypes?.GET_PROMOTIONS_DATA, getPromotionsData);
  yield takeLatest(
    actionTypes?.GET_PROMOTIONS_SALES_DATA,
    getPromotionsSalesData
  );
  // expenses
  yield takeLatest(actionTypes?.GET_EXPENSES_DATA, getExpensesData);
  // payments
  yield takeLatest(actionTypes?.GET_PAYMENTS_DATA, getPaymentsData);
  yield takeLatest(actionTypes?.ADD_PAYMENTS_FORM_DATA, getAddPaymentsFormData);
  yield takeLatest(
    actionTypes?.POST_ADD_PAYMENTS_FORM_DATA,
    postAddPaymentsFormData
  );
  yield takeLatest(actionTypes?.GET_EXPENSE_TYPE_DATA, getExpenseTypeData);
  yield takeLatest(actionTypes?.GET_INVOICES_DATA, getInvoicesData);
  yield takeLatest(
    actionTypes?.GET_PAY_TRADE_LIABILITY_DATA,
    getPayTradeLiabilityData
  );
  yield takeLatest(actionTypes?.GET_PAY_OTHER_DEBT_DATA, getPayOtherDebtData);
  yield takeLatest(actionTypes?.GET_BUY_ASSET_DATA, getBuyAssetData);
  yield takeLatest(
    actionTypes?.GET_PAYMENT_ACCOUNT_DATA,
    getPaymentAccountData
  );
  yield takeLatest(actionTypes?.GET_ADD_ASSET_DATA, getAddAssetData);
  yield takeLatest(actionTypes?.POST_ADD_ASSET_DATA, postAddAssetData);
  yield takeLatest(
    actionTypes?.POST_DELETE_ADD_ASSET_DATA,
    postDeleteAddAssetData
  );
  yield takeLatest(actionTypes?.GET_AP_LIABILITY_DATA, getApLiabilityData);
  yield takeLatest(actionTypes?.GET_VIEW_PAYMENT_DATA, getViewPaymentData);
  yield takeLatest(actionTypes?.GET_EDIT_PAYMENT_DATA, getEditPaymentData);
  yield takeLatest(actionTypes?.POST_EDIT_PAYMENT_DATA, postEditPaymentData);

  yield takeLatest(
    actionTypes?.GET_APPROVED_PAYMENTS_DATA,
    getApprovedPaymentsData
  );
  yield takeLatest(
    actionTypes?.GET_PENDING_PAYMENTS_DATA,
    getPendingPaymentsData
  );
  yield takeLatest(
    actionTypes?.GET_REJECTED_PAYMENTS_DATA,
    getRejectedPaymentsData
  );
  yield takeLatest(
    actionTypes?.GET_SUBMITTED_PAYMENTS_DATA,
    getSubmittedPaymentsData
  );
  yield takeLatest(
    actionTypes?.POST_APPROVED_PAYMENTS_DATA,
    postApprovedPaymentsData
  );

  // finance payables oustanding
  yield takeLatest(
    actionTypes.GET_FINANCE_PAYABLES_OUTSTANDING,
    getFinancePayablesOutstanding
  );
  yield takeLatest(
    actionTypes.GET_FINANCE_AP_CREDIT_NOTES,
    getFinanceApCreditNotes
  );
  yield takeLatest(
    actionTypes.GET_AP_CREDIT_NOTES_OPTION,
    getApCreditNotesOption
  );
  yield takeLatest(
    actionTypes.GET_AP_CREDIT_NOTES_TAX_PERCENTAGE,
    getApCreditNotesTaxPercentage
  );
  yield takeLatest(
    actionTypes.POST_AP_CREDIT_NOTES_DATA,
    postApCreditNotesData
  );
  yield takeLatest(
    actionTypes.GET_EDIT_AP_CREDIT_NOTES_DATA,
    getEditApCreditNotesData
  );
  yield takeLatest(
    actionTypes.POST_CREDI_NOTES_ATTACHMENT,
    postCreditNotesAttachment
  );
  yield takeLatest(actionTypes.GET_FINANCE_ASSETS, getFinanceAssets);
  yield takeLatest(actionTypes.DOWNLOAD_FINANCE_ASSETS, downloadFinanceAssets);

  // finance voucher
  yield takeLatest(actionTypes.GET_FINANCE_VOUCHERS, getFinanceVouchers);
  yield takeLatest(
    actionTypes.GET_FINANCE_VOUCHERS_LIST,
    getFinanceVouchersList
  );
  yield takeLatest(
    actionTypes.DOWNLOAD_FINANCE_VOUCHER,
    downloadFinanceVoucher
  );
}

export default financeSaga;
